import { render } from "./Box.vue?vue&type=template&id=2213b766"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"
script.render = render

export default script